import { useAtomValue } from 'jotai';
import { lazy, Suspense } from 'react';
import { cancellationConfirmationModalOpenAtom } from '../billingAtoms';

const CancellationConfirmationModalImplementation = lazy(() =>
  import('./cancellation-confirmation-modal-implementation').then((mod) => ({
    default: mod.CancellationConfirmationModalImplementation,
  }))
);

/** Lazy gate for paid cancel flow (intent → reason). */
export function CancellationConfirmationModal() {
  const isOpen = useAtomValue(cancellationConfirmationModalOpenAtom);

  if (!isOpen) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <CancellationConfirmationModalImplementation />
    </Suspense>
  );
}
